import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, Validators, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { AddressService, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { CountryAndRegionsModule } from '@fgb/portal-component-library/src/lib/shared/country-and-regions';
import { __awaiter } from 'tslib';
import { RegexUS } from '@fgb/portal-component-library/src/lib/shared/utilities';
import { tap } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/forms';
import * as ɵngcc2 from '@fgb/core';
import * as ɵngcc3 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc4 from '@angular/common';
import * as ɵngcc5 from '@fgb/portal-component-library/src/lib/shared/country-and-regions';
import * as ɵngcc6 from '@ngx-translate/core';

function TopUpAddressComponent_form_3_div_2_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "address.missing.firstname"));
} }
function TopUpAddressComponent_form_3_div_2_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵtemplate(1, TopUpAddressComponent_form_3_div_2_div_5_div_1_Template, 3, 3, "div", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r10.f.firstName.errors.required);
} }
function TopUpAddressComponent_form_3_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "label", 11);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "input", 12);
    ɵngcc0.ɵɵtemplate(5, TopUpAddressComponent_form_3_div_2_div_5_Template, 2, 1, "div", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "address.firstname.label"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.submitted && ctx_r1.f.firstName.errors);
} }
function TopUpAddressComponent_form_3_div_3_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "address.missing.surname"));
} }
function TopUpAddressComponent_form_3_div_3_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵtemplate(1, TopUpAddressComponent_form_3_div_3_div_5_div_1_Template, 3, 3, "div", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r12.f.surname.errors.required);
} }
function TopUpAddressComponent_form_3_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "label", 16);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "input", 17);
    ɵngcc0.ɵɵtemplate(5, TopUpAddressComponent_form_3_div_3_div_5_Template, 2, 1, "div", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "address.surname.label"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.submitted && ctx_r2.f.surname.errors);
} }
function TopUpAddressComponent_form_3_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵelementStart(1, "label", 19);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "input", 20);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, "address.name.label"));
} }
function TopUpAddressComponent_form_3_div_5_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "address.missing.street"));
} }
function TopUpAddressComponent_form_3_div_5_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵtemplate(1, TopUpAddressComponent_form_3_div_5_div_5_div_1_Template, 3, 3, "div", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r14.f.street.errors.required);
} }
function TopUpAddressComponent_form_3_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "label", 21);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "input", 22);
    ɵngcc0.ɵɵtemplate(5, TopUpAddressComponent_form_3_div_5_div_5_Template, 2, 1, "div", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "address.street.label"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.submitted && ctx_r4.f.street.errors);
} }
function TopUpAddressComponent_form_3_div_6_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "address.missing.city"));
} }
function TopUpAddressComponent_form_3_div_6_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵtemplate(1, TopUpAddressComponent_form_3_div_6_div_5_div_1_Template, 3, 3, "div", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r16.f.town.errors.required);
} }
function TopUpAddressComponent_form_3_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "label", 23);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "input", 24);
    ɵngcc0.ɵɵtemplate(5, TopUpAddressComponent_form_3_div_6_div_5_Template, 2, 1, "div", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "address.city.label"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.submitted && ctx_r5.f.town.errors);
} }
function TopUpAddressComponent_form_3_fgbcl_country_and_regions_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fgbcl-country-and-regions", 25);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("Form", ctx_r6.topUpAddressForm)("HasSubmitted", ctx_r6.submitted);
} }
function TopUpAddressComponent_form_3_div_8_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "address.missing.postcode"));
} }
function TopUpAddressComponent_form_3_div_8_div_5_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "address.invalid.postcode"));
} }
function TopUpAddressComponent_form_3_div_8_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵtemplate(1, TopUpAddressComponent_form_3_div_8_div_5_div_1_Template, 3, 3, "div", 15);
    ɵngcc0.ɵɵtemplate(2, TopUpAddressComponent_form_3_div_8_div_5_div_2_Template, 3, 3, "div", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r18.f.postCode.errors.required);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r18.f.postCode.errors.pattern);
} }
function TopUpAddressComponent_form_3_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "label", 26);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "input", 27);
    ɵngcc0.ɵɵtemplate(5, TopUpAddressComponent_form_3_div_8_div_5_Template, 3, 2, "div", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "address.postcode.label"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.submitted && ctx_r7.f.postCode.errors);
} }
function TopUpAddressComponent_form_3_div_9_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "address.missing.number"));
} }
function TopUpAddressComponent_form_3_div_9_div_5_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "address.invalid.number"));
} }
function TopUpAddressComponent_form_3_div_9_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵtemplate(1, TopUpAddressComponent_form_3_div_9_div_5_div_1_Template, 3, 3, "div", 15);
    ɵngcc0.ɵɵtemplate(2, TopUpAddressComponent_form_3_div_9_div_5_div_2_Template, 3, 3, "div", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r21.f.mobileNumber.errors.required);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r21.f.mobileNumber.errors.pattern);
} }
function TopUpAddressComponent_form_3_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "label", 28);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "input", 29);
    ɵngcc0.ɵɵtemplate(5, TopUpAddressComponent_form_3_div_9_div_5_Template, 3, 2, "div", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "address.number.label"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8.submitted && ctx_r8.f.mobileNumber.errors);
} }
function TopUpAddressComponent_form_3_div_10_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "address.missing.email"));
} }
function TopUpAddressComponent_form_3_div_10_div_5_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "address.invalid.email"));
} }
function TopUpAddressComponent_form_3_div_10_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵtemplate(1, TopUpAddressComponent_form_3_div_10_div_5_div_1_Template, 3, 3, "div", 15);
    ɵngcc0.ɵɵtemplate(2, TopUpAddressComponent_form_3_div_10_div_5_div_2_Template, 3, 3, "div", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r24.f.emailAddress.errors.required);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r24.f.emailAddress.errors.pattern);
} }
function TopUpAddressComponent_form_3_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵelementStart(1, "label", 30);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "input", 31);
    ɵngcc0.ɵɵtemplate(5, TopUpAddressComponent_form_3_div_10_div_5_Template, 3, 2, "div", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "address.email.label"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r9.submitted && ctx_r9.f.emailAddress.errors);
} }
function TopUpAddressComponent_form_3_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "form", 2);
    ɵngcc0.ɵɵlistener("ngSubmit", function TopUpAddressComponent_form_3_Template_form_ngSubmit_0_listener() { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r27 = ɵngcc0.ɵɵnextContext(); return ctx_r27.save(ctx_r27.topUpAddressForm.value, ctx_r27.topUpAddressForm.valid); });
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵtemplate(2, TopUpAddressComponent_form_3_div_2_Template, 6, 4, "div", 4);
    ɵngcc0.ɵɵtemplate(3, TopUpAddressComponent_form_3_div_3_Template, 6, 4, "div", 4);
    ɵngcc0.ɵɵtemplate(4, TopUpAddressComponent_form_3_div_4_Template, 5, 3, "div", 5);
    ɵngcc0.ɵɵtemplate(5, TopUpAddressComponent_form_3_div_5_Template, 6, 4, "div", 4);
    ɵngcc0.ɵɵtemplate(6, TopUpAddressComponent_form_3_div_6_Template, 6, 4, "div", 4);
    ɵngcc0.ɵɵtemplate(7, TopUpAddressComponent_form_3_fgbcl_country_and_regions_7_Template, 1, 2, "fgbcl-country-and-regions", 6);
    ɵngcc0.ɵɵtemplate(8, TopUpAddressComponent_form_3_div_8_Template, 6, 4, "div", 4);
    ɵngcc0.ɵɵtemplate(9, TopUpAddressComponent_form_3_div_9_Template, 6, 4, "div", 4);
    ɵngcc0.ɵɵtemplate(10, TopUpAddressComponent_form_3_div_10_Template, 6, 4, "div", 5);
    ɵngcc0.ɵɵelementStart(11, "div", 7);
    ɵngcc0.ɵɵelementStart(12, "button", 8);
    ɵngcc0.ɵɵlistener("click", function TopUpAddressComponent_form_3_Template_button_click_12_listener() { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r29 = ɵngcc0.ɵɵnextContext(); return ctx_r29.cancel(); });
    ɵngcc0.ɵɵtext(13);
    ɵngcc0.ɵɵpipe(14, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "button", 9);
    ɵngcc0.ɵɵtext(16);
    ɵngcc0.ɵɵpipe(17, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.topUpAddressForm);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.topUpAddressConfig.showFirstName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.topUpAddressConfig.showLastName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.topUpAddressConfig.showAddressName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.topUpAddressConfig.showStreet);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.topUpAddressConfig.showTown);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.topUpAddressConfig.showCountryRegion);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.topUpAddressConfig.showPostCode);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.topUpAddressConfig.showMobileNumber);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.topUpAddressConfig.showEmail);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(14, 12, "address.cancel.label"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(17, 14, "address.confirm.label"), " ");
} }
const topUpAddressConfigDefault = {
    showFirstName: true,
    showLastName: true,
    showAddressName: false,
    showStreet: true,
    showTown: true,
    showCountryRegion: true,
    showPostCode: true,
    showMobileNumber: true,
    showEmail: true,
};

class TopUpAddressComponent {
    constructor(formBuilder, addressService, modalService) {
        this.formBuilder = formBuilder;
        this.addressService = addressService;
        this.modalService = modalService;
        this.regex = RegexUS;
        this.topUpAddressConfig = topUpAddressConfigDefault;
        this.submittedAddress = new EventEmitter();
        this.submitted = false;
    }
    ngOnInit() {
        this.addressService
            .getTopUpAddress()
            .pipe(tap((address) => this.setupAddressForm(address)))
            .subscribe();
    }
    get f() {
        return this.topUpAddressForm.controls;
    }
    save(address, isValid) {
        return __awaiter(this, void 0, void 0, function* () {
            this.submitted = true;
            if (isValid) {
                yield this.addressService.postTopUpAddress(address);
                this.submittedAddress.emit(true);
            }
        });
    }
    cancel() {
        this.submittedAddress.emit(false);
        this.modalService.dismissAll();
    }
    setupAddressForm(topUpAddress) {
        this.topUpAddressForm = this.formBuilder.group({});
        if (this.topUpAddressConfig.showFirstName)
            this.topUpAddressForm.addControl('firstName', new FormControl(topUpAddress.FirstName, Validators.required));
        if (this.topUpAddressConfig.showLastName)
            this.topUpAddressForm.addControl('surname', new FormControl(topUpAddress.Surname, Validators.required));
        if (this.topUpAddressConfig.showAddressName)
            this.topUpAddressForm.addControl('addressName', new FormControl(topUpAddress.AddressName));
        if (this.topUpAddressConfig.showStreet)
            this.topUpAddressForm.addControl('street', new FormControl(topUpAddress.Street, Validators.required));
        if (this.topUpAddressConfig.showTown)
            this.topUpAddressForm.addControl('town', new FormControl(topUpAddress.Town, Validators.required));
        if (this.topUpAddressConfig.showPostCode)
            this.topUpAddressForm.addControl('postCode', new FormControl(topUpAddress.Postcode, [Validators.required, Validators.pattern(this.regex.postCode)]));
        if (this.topUpAddressConfig.showCountryRegion) {
            this.topUpAddressForm.addControl('Country', new FormControl(topUpAddress.Country, Validators.required));
            this.topUpAddressForm.addControl('County', new FormControl(topUpAddress.County, Validators.required));
        }
        if (this.topUpAddressConfig.showMobileNumber)
            this.topUpAddressForm.addControl('mobileNumber', new FormControl(topUpAddress.HomeNumber, [Validators.required, Validators.pattern(this.regex.number)]));
        if (this.topUpAddressConfig.showEmail)
            this.topUpAddressForm.addControl('emailAddress', new FormControl(topUpAddress.EmailAddress, [Validators.required, Validators.pattern(this.regex.email)]));
    }
}
TopUpAddressComponent.ɵfac = function TopUpAddressComponent_Factory(t) { return new (t || TopUpAddressComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.FormBuilder), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.AddressService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgbModal)); };
TopUpAddressComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TopUpAddressComponent, selectors: [["fgbcl-top-up-address"]], inputs: { regex: "regex", topUpAddressConfig: "topUpAddressConfig" }, outputs: { submittedAddress: "submittedAddress" }, decls: 4, vars: 4, consts: [[1, "mt-3", "font-weight-bold", "text-danger", "text-center"], [3, "formGroup", "ngSubmit", 4, "ngIf"], [3, "formGroup", "ngSubmit"], [1, "d-flex", "flex-row", "flex-wrap", "top-up-address"], ["class", "form-group col-lg-6", 4, "ngIf"], ["class", "form-group col-lg-12", 4, "ngIf"], ["style", "padding: 0 11px", 3, "Form", "HasSubmitted", 4, "ngIf"], [1, "form-group", "btn-container", "col-lg-12", "mt-3", "mb-0"], ["type", "button", "id", "cancelButton", 1, "btn", "btn-black", "font-weight-bold", 3, "click"], ["type", "submit", "id", "saveButton", 1, "btn", "btn-success", "mb-0", "float-right", "font-weight-bold"], [1, "form-group", "col-lg-6"], ["for", "firstName"], ["type", "text", "formControlName", "firstName", "id", "firstName", 1, "form-control"], ["class", "alert alert-danger", 4, "ngIf"], [1, "alert", "alert-danger"], [4, "ngIf"], ["for", "surname"], ["type", "text", "formControlName", "surname", "id", "surname", 1, "form-control"], [1, "form-group", "col-lg-12"], ["for", "addressName"], ["type", "text", "formControlName", "addressName", "id", "addressName", 1, "form-control"], ["for", "street"], ["type", "text", "formControlName", "street", "id", "street", 1, "form-control"], ["for", "town"], ["type", "text", "formControlName", "town", "id", "town", 1, "form-control"], [2, "padding", "0 11px", 3, "Form", "HasSubmitted"], ["for", "postCode"], ["type", "text", "formControlName", "postCode", "id", "postCode", 1, "form-control"], ["for", "mobileNumber"], ["type", "text", "formControlName", "mobileNumber", "id", "mobileNumber", 1, "form-control"], ["for", "emailAddress"], ["type", "text", "formControlName", "emailAddress", "id", "emailAddress", 1, "form-control"]], template: function TopUpAddressComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵpipe(2, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, TopUpAddressComponent_form_3_Template, 18, 16, "form", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 2, "payment.address.description"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.topUpAddressForm);
    } }, directives: [ɵngcc4.NgIf, ɵngcc1.ɵangular_packages_forms_forms_ba, ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc1.DefaultValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName, ɵngcc5.CountryAndRegionsComponent], pipes: [ɵngcc6.TranslatePipe], styles: [""] });
TopUpAddressComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: AddressService },
    { type: NgbModal }
];
TopUpAddressComponent.propDecorators = {
    regex: [{ type: Input }],
    topUpAddressConfig: [{ type: Input }],
    submittedAddress: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TopUpAddressComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-top-up-address',
                template: "<p class=\"mt-3 font-weight-bold text-danger text-center\">{{ 'payment.address.description' | translate }}</p>\r\n\r\n<form *ngIf=\"topUpAddressForm\" [formGroup]=\"topUpAddressForm\" (ngSubmit)=\"save(topUpAddressForm.value, topUpAddressForm.valid)\">\r\n  <div class=\"d-flex flex-row flex-wrap top-up-address\">\r\n    <div class=\"form-group col-lg-6\" *ngIf=\"topUpAddressConfig.showFirstName\">\r\n      <label for=\"firstName\">{{ 'address.firstname.label' | translate }}</label>\r\n      <input type=\"text\" formControlName=\"firstName\" id=\"firstName\" class=\"form-control\" />\r\n      <div *ngIf=\"submitted && f.firstName.errors\" class=\"alert alert-danger\">\r\n        <div *ngIf=\"f.firstName.errors.required\">{{ 'address.missing.firstname' | translate }}</div>\r\n      </div>\r\n    </div>\r\n    <div class=\"form-group col-lg-6\" *ngIf=\"topUpAddressConfig.showLastName\">\r\n      <label for=\"surname\">{{ 'address.surname.label' | translate }}</label>\r\n      <input type=\"text\" formControlName=\"surname\" id=\"surname\" class=\"form-control\" />\r\n      <div *ngIf=\"submitted && f.surname.errors\" class=\"alert alert-danger\">\r\n        <div *ngIf=\"f.surname.errors.required\">{{ 'address.missing.surname' | translate }}</div>\r\n      </div>\r\n    </div>\r\n    <div class=\"form-group col-lg-12\" *ngIf=\"topUpAddressConfig.showAddressName\">\r\n      <label for=\"addressName\">{{ 'address.name.label' | translate }}</label>\r\n      <input type=\"text\" formControlName=\"addressName\" id=\"addressName\" class=\"form-control\" />\r\n    </div>\r\n    <div class=\"form-group col-lg-6\" *ngIf=\"topUpAddressConfig.showStreet\">\r\n      <label for=\"street\">{{ 'address.street.label' | translate }}</label>\r\n      <input type=\"text\" formControlName=\"street\" id=\"street\" class=\"form-control\" />\r\n      <div *ngIf=\"submitted && f.street.errors\" class=\"alert alert-danger\">\r\n        <div *ngIf=\"f.street.errors.required\">{{ 'address.missing.street' | translate }}</div>\r\n      </div>\r\n    </div>\r\n    <div class=\"form-group col-lg-6\" *ngIf=\"topUpAddressConfig.showTown\">\r\n      <label for=\"town\">{{ 'address.city.label' | translate }}</label>\r\n      <input type=\"text\" formControlName=\"town\" id=\"town\" class=\"form-control\" />\r\n      <div *ngIf=\"submitted && f.town.errors\" class=\"alert alert-danger\">\r\n        <div *ngIf=\"f.town.errors.required\">{{ 'address.missing.city' | translate }}</div>\r\n      </div>\r\n    </div>\r\n    <fgbcl-country-and-regions\r\n      style=\"padding: 0 11px\"\r\n      *ngIf=\"topUpAddressConfig.showCountryRegion\"\r\n      [Form]=\"topUpAddressForm\"\r\n      [HasSubmitted]=\"submitted\"\r\n    >\r\n    </fgbcl-country-and-regions>\r\n    <div class=\"form-group col-lg-6\" *ngIf=\"topUpAddressConfig.showPostCode\">\r\n      <label for=\"postCode\">{{ 'address.postcode.label' | translate }}</label>\r\n      <input type=\"text\" formControlName=\"postCode\" id=\"postCode\" class=\"form-control\" />\r\n      <div *ngIf=\"submitted && f.postCode.errors\" class=\"alert alert-danger\">\r\n        <div *ngIf=\"f.postCode.errors.required\">{{ 'address.missing.postcode' | translate }}</div>\r\n        <div *ngIf=\"f.postCode.errors.pattern\">{{ 'address.invalid.postcode' | translate }}</div>\r\n      </div>\r\n    </div>\r\n    <div class=\"form-group col-lg-6\" *ngIf=\"topUpAddressConfig.showMobileNumber\">\r\n      <label for=\"mobileNumber\">{{ 'address.number.label' | translate }}</label>\r\n      <input type=\"text\" formControlName=\"mobileNumber\" id=\"mobileNumber\" class=\"form-control\" />\r\n      <div *ngIf=\"submitted && f.mobileNumber.errors\" class=\"alert alert-danger\">\r\n        <div *ngIf=\"f.mobileNumber.errors.required\">{{ 'address.missing.number' | translate }}</div>\r\n        <div *ngIf=\"f.mobileNumber.errors.pattern\">{{ 'address.invalid.number' | translate }}</div>\r\n      </div>\r\n    </div>\r\n    <div class=\"form-group col-lg-12\" *ngIf=\"topUpAddressConfig.showEmail\">\r\n      <label for=\"emailAddress\">{{ 'address.email.label' | translate }}</label>\r\n      <input type=\"text\" formControlName=\"emailAddress\" id=\"emailAddress\" class=\"form-control\" />\r\n      <div *ngIf=\"submitted && f.emailAddress.errors\" class=\"alert alert-danger\">\r\n        <div *ngIf=\"f.emailAddress.errors.required\">{{ 'address.missing.email' | translate }}</div>\r\n        <div *ngIf=\"f.emailAddress.errors.pattern\">{{ 'address.invalid.email' | translate }}</div>\r\n      </div>\r\n    </div>\r\n    <div class=\"form-group btn-container col-lg-12 mt-3 mb-0\">\r\n      <button type=\"button\" class=\"btn btn-black font-weight-bold\" id=\"cancelButton\" (click)=\"cancel()\">\r\n        {{ 'address.cancel.label' | translate }}\r\n      </button>\r\n      <button type=\"submit\" class=\"btn btn-success mb-0 float-right font-weight-bold\" id=\"saveButton\">\r\n        {{ 'address.confirm.label' | translate }}\r\n      </button>\r\n    </div>\r\n  </div>\r\n</form>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc1.FormBuilder }, { type: ɵngcc2.AddressService }, { type: ɵngcc3.NgbModal }]; }, { regex: [{
            type: Input
        }], topUpAddressConfig: [{
            type: Input
        }], submittedAddress: [{
            type: Output
        }] }); })();

class TopUpAddressModule {
}
TopUpAddressModule.ɵfac = function TopUpAddressModule_Factory(t) { return new (t || TopUpAddressModule)(); };
TopUpAddressModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TopUpAddressModule });
TopUpAddressModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            CountryAndRegionsModule,
            NgbModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TopUpAddressModule, { declarations: function () { return [TopUpAddressComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        CountryAndRegionsModule,
        NgbModule, ɵngcc6.TranslateModule]; }, exports: function () { return [TopUpAddressComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TopUpAddressModule, [{
        type: NgModule,
        args: [{
                declarations: [TopUpAddressComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    CountryAndRegionsModule,
                    NgbModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [TopUpAddressComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TopUpAddressComponent, TopUpAddressModule, topUpAddressConfigDefault };

//# sourceMappingURL=fgb-portal-component-library-src-lib-shared-top-up-address.js.map